import { Col, Row } from 'antd';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { defaultAvatarImg } from '../../constants';
import { dateCommon, formatVND, thoiGianCongTacCommon } from '../../helpers/common';
import { BacLuongResponse, ChiTietHopDongResponse } from '../../models/hopdong/HopDong';
import { NhanVienResponse } from '../../models/nhanvien/NhanVien';
import { QuaTrinhLamViecReponse } from '../../models/nhanvien/QuaTrinhLamViec';
import { TrinhDoHocVanResponse } from '../../models/nhanvien/TrinhDoHocVan';
import { layCTHopDong, layDsHopDongTheoIdNhanVien } from '../../services/hopdong';
import { layCTNhanVien } from '../../services/nhanvien';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const PrintPage = styled.div`
  @media print {
    /* Thiết lập lề và kích thước giấy A4 */
    @page {
      width: 210mm
      background-color: white;
      font-family: "Times New Roman", Times, serif;
    }

    /* Thiết lập phân trang */
    div {
      page-break-inside: avoid;
    }
    
    /* Định dạng các trang in */
    @page {
      size: A4 landscape;
      margin-top: 2cm;
      margin-bottom: 2cm;
      margin-left: 3cm;
      margin-right: 2cm;
    }
  }
`;

const InHoSoNhanVienMoi = ({ idNhanVien }: { idNhanVien: number }) => {
    const [nhanVien, setNhanVien] = useState<NhanVienResponse>(new NhanVienResponse);
    const [bacLuongInfo, setBacLuongInfo] = useState<BacLuongResponse>(new BacLuongResponse);
    const [trinhDoHocVanInfo, setTrinhDoHocVanInfo] = useState<Array<TrinhDoHocVanResponse>>([]);
    const [hopDongInfo, setHopDongInfo] = useState<ChiTietHopDongResponse>(new ChiTietHopDongResponse);
    const [qTCTInfo, setQTCTInfo] = useState<Array<QuaTrinhLamViecReponse>>([]);
    const dispatch = useDispatch();

    const layDuLieu = async (idNhanVien: number) => {
        dispatch(showLoadingScreen());
        try {
            let kq = await layCTNhanVien(idNhanVien);
            setNhanVien(kq);
            setTrinhDoHocVanInfo(kq.trinhDoHocVans);
            setQTCTInfo(kq.quaTrinhLamViecs)
            dispatch(hideLoadingScreen());
        } catch (err) {
            dispatch(hideLoadingScreen());
        }
    }

    const layChiTietHopDong = async (idNV: number) => {
        try {
            if (idNV > 0) {
                dispatch(showLoadingScreen());
                var rs = await layDsHopDongTheoIdNhanVien(idNV);
                dispatch(hideLoadingScreen());
                if (rs.dsHopDong.length > 0) {
                    var selectDefault = rs.dsHopDong.find(x => x.trangThai === 1) || rs.dsHopDong[0];
                    if (selectDefault.id > 0) {
                        var data = await layCTHopDong(selectDefault.id);
                        setHopDongInfo(data);
                        if (data.bacLuong.length > 0) {
                            setBacLuongInfo(data.bacLuong[0]);
                        }
                    }
                }
            }
        }
        catch (error: any) {
            toast.error('Có lỗi xảy ra, hãy thử lại sau!')
        }
    };

    useEffect(() => {
        if (idNhanVien > 0 && idNhanVien != undefined) {
            layDuLieu(idNhanVien);
            layChiTietHopDong(idNhanVien);
        }
    }, [idNhanVien]);

    return (
        <div style={{ backgroundColor: 'white' }}>
            <PrintPage >
                <Row gutter={8}  >
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginLeft: '5mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        UBND THÀNH PHỐ ĐÀ NẴNG
                        <br />
                        <span style={{ display: "block", textAlign: "left", marginLeft: '2mm', fontWeight: "bold", fontFamily: 'Times New Roman' }}>
                            QUỸ ĐẦU TƯ PHÁT TRIỂN
                            <hr style={{ borderTop: "1px solid", width: "50%", height: "10%", marginLeft: '2mm', marginTop: "1px", marginBottom: "2px" }} />
                        </span>
                    </Col>
                    <Col span={15} className="right-col" style={{ textAlign: 'right', marginRight: '12mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        CỘNG HÒA XÃ HỘI CHỦ NGHĨA VIỆT NAM
                        <br />
                        <span style={{ display: "block", textAlign: "right", marginRight: '15mm', fontFamily: 'Times New Roman' }}>
                            Độc lập - Tự do - Hạnh phúc
                            <hr style={{ borderTop: "1px solid", marginTop: "1px", marginLeft: '168mm', width: "20%", height: "10%"}} />
                        </span>
                    </Col>
                </Row>
                <Row justify="center">
                    <Col
                        span={24}
                        style={{ textAlign: "center", marginTop: "5mm", fontWeight: "bold", fontSize: "20px", fontFamily: 'Times New Roman' }}
                    >
                        SƠ YẾU LÝ LỊCH CÁ NHÂN
                    </Col>
                </Row>
                <Row gutter={8} >
                    <Col span={8}>
                        <div style={{ textAlign: 'center' }}>
                            <img
                                className="profile-user-img img-fluid img-square"
                                style={{ width: '150px', height: '180px' }}
                                src={
                                    nhanVien?.avatar == null || nhanVien?.avatar === ""
                                        ? defaultAvatarImg
                                        : `/${nhanVien?.avatar.replace(/\\/g, "/")}`
                                }
                                alt="User profile picture"
                            />
                        </div>
                    </Col>
                    <Col span={16}>
                        <Row className="form-group" gutter={10}>
                            <Col span={12} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                                1) Họ và tên khai sinh (chữ in hoa): {nhanVien && nhanVien.hoTen ? nhanVien.hoTen.toUpperCase() : ''}
                            </Col>
                        </Row>
                        <Row className="form-group" gutter={8}>
                            <Col span={12} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                                2) Tên gọi khác: Không
                            </Col>
                        </Row>
                        <Row className="form-group" gutter={6}>
                            <Col span={5} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                                3) Sinh ngày: {dateCommon.formatDate(nhanVien?.ngaySinh)}
                            </Col>
                            <Col span={7} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                                Giới tính (Nam, Nữ):  {nhanVien?.gioiTinh === 0 ? "Nam" : "Nữ"}
                            </Col>
                        </Row>
                        <Row className="form-group" gutter={8}>
                            <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                                4) Nơi sinh:   {nhanVien.noiSinh}
                            </Col>
                        </Row>
                        <Row className="form-group" gutter={8}>
                            <Col span={12} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                                5) Quê quán:  {nhanVien.queQuan}
                            </Col>
                        </Row>
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        6) Dân tộc: {nhanVien.tenDanToc}
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        7) Tôn giáo: {nhanVien.tenTonGiao}
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        8) Nơi đăng ký hộ khẩu thường trú: {[nhanVien?.soNhaThuongTru, nhanVien?.tenPhuongXaThuongTru, nhanVien?.tenTinhThanhThuongTru].filter(x => x).join(", ")}
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        9) Nơi ở hiện nay:  {[nhanVien?.soNhaNoiO, nhanVien?.tenPhuongXaNoiO, nhanVien?.tenTinhThanhNoiO].filter(x => x).join(", ")}
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={12} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        10) Nghề nghiệp khi được tuyển dụng:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={8} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        11.1) Ngày vào làm: {dateCommon.formatDate(nhanVien?.ngayVaoLam)}
                    </Col>
                    <Col span={8} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        11.2) Ngày tính phép: {dateCommon.formatDate(nhanVien?.ngayTinhPhep)}
                    </Col>
                    <Col span={8} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        11.3) Thời gian làm CQNN trước khi vào Quỹ: {thoiGianCongTacCommon.hienThi(nhanVien?.soThangLamCQNN)}
                    </Col>
                </Row>
                {/*  Tên chức vụ + tên đơn vị + tên Quỹ */}
                <Row className="form-group" gutter={8}>
                    <Col span={16} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        12.1-Chức danh (chức vụ) công tác hiện tại:   {nhanVien.tenChucVu + (nhanVien.idDonVi !== 2 ? " tại " + nhanVien?.tenDonVi + " " : " tại") + " Quỹ Đầu tư phát triển thành phố Đà Nẵng"}
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        12.1-Chức danh (chức vụ) kiêm nhiệm:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        13) Công việc chính được giao:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        14) Chức danh nghề nghiệp:
                    </Col>
                    <Col span={6} className="right-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Mã số:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        15.1- Trình độ giáo dục phổ thông (đã tốt nghiệp lớp mấy/thuộc hệ nào): {nhanVien?.tenTrinhDoVanHoa}
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        15.2-Trình độ chuyên môn cao nhất: {nhanVien?.tenHocHam}
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        15.3-Lý luận chính trị: {nhanVien?.tenTrinhDoLLCT}
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        15.4-Quản lý nhà nước:
                    </Col>
                </Row>
                {/*in Nghieng Chữ nhỏ*/}
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>
                        (Cử nhân, cao cấp, trung cấp, sơ cấp)
                    </Col>
                    <Col span={9} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>
                        (Chuyên viên cao cấp, chuyên viên chính, chuyên viên, cán sự.)
                    </Col>
                </Row>
                {/* 15.6 và 15.7 đã chuyển thành bảng 26.1 và 26.2 */}
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        16) Ngày vào Đảng Cộng sản Việt Nam: {(nhanVien?.isDangVien ? " " + dateCommon.formatDate(nhanVien?.ttDangVien?.ngayKetNap) : "")}
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Ngày chính thức: {(nhanVien?.isDangVien ? " " + dateCommon.formatDate(nhanVien?.ttDangVien?.ngayChinhThuc) : "")}
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        17) Ngày tham gia tổ chức chính trị - xã hội:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>
                        (Ngày tham gia tổ chức: Đoàn, Hội, …. và  làm việc gì trong tổ chức đó)
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        18) Ngày nhập ngũ:
                    </Col>
                    <Col span={6} className="right-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Ngày xuất ngũ:
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Quân hàm cao nhất:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        19.1- Danh hiệu được phong tặng cao nhất:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={13} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>
                        (Anh hùng lao động, anh hùng lực lượng vũ trang: nhà giáo, thầy thuốc, nghệ sĩ nhân dân ưu tú,…)
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={12} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        19.2- Học hàm được phong (Giáo sư, Phó giáo sư):
                    </Col>
                    <Col span={6} className="right-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Năm được phong:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        20) Sở trường công tác:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        21) Tình trạng sức khoẻ:
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Chiều cao:
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Cân nặng:
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Nhóm máu:
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        22) Là thương binh hạng:
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Là con gia đình chính sách:
                    </Col>
                </Row>
                {/*in Nghieng Chữ nhỏ*/}
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>

                    </Col>
                    <Col span={10} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>
                        (Con thương binh, con liệt sĩ, người nhiễm chất độc da cam, Dioxin)
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        23) Số căn cước công dân: {nhanVien.cccd}
                    </Col>
                    <Col span={6} className="right-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        Ngày cấp: {dateCommon.formatDate(nhanVien?.ngayCapCCCD)}
                    </Col>
                    <Col span={6} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        24) Sổ BHXH: {nhanVien?.soBHXH}
                    </Col>
                </Row>
                {/* 25.1) KHEN THƯỞNG */}
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '2mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        25.1) KHEN THƯỞNG
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Ngày quyết định</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Số quyết định</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Thành tích khen thưởng</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Hình thức khen thưởng</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Đơn vị ký quyết định</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nhanVien.khenThuongs && nhanVien.khenThuongs.length > 0
                                    ? nhanVien.khenThuongs
                                        .sort((a, b) => new Date(a.ngayQuyetDinh).getTime() - new Date(b.ngayQuyetDinh).getTime())
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.ngayQuyetDinh)}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.soQuyetDinh}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.thanhTichKhenThuong}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.hinhThucKhenThuong}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.donViKyQuyetDinh}</td>
                                            </tr>
                                        ))
                                    : <tr><td style={{ border: '1px solid black', padding: '2px 4px' }} colSpan={5}>&nbsp;</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Row>
                {/* 25.2) KỶ LUẬT */}
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '2mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        25.2) KỶ LUẬT
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Ngày quyết định</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Số quyết định</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Nội dung kỷ luật</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Hình thức kỷ luật</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Đơn vị ký quyết định</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nhanVien.kyLuats && nhanVien.kyLuats.length > 0
                                    ? nhanVien.kyLuats
                                        .sort((a, b) => new Date(a.ngayQuyetDinh).getTime() - new Date(b.ngayQuyetDinh).getTime())
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.ngayQuyetDinh)}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.soQuyetDinh}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.noiDungKyLuat}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.hinhThucKyLuat}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.donViKyQuyetDinh}</td>
                                            </tr>
                                        ))
                                    : <tr><td style={{ border: '1px solid black', padding: '2px 4px' }} colSpan={5}>&nbsp;</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Row>
                {/* 26.1) CHỨNG CHỈ NGOẠI NGỮ */}
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '2mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        26.1) CHỨNG CHỈ NGOẠI NGỮ
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Tên chứng chỉ</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Đơn vị cấp</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Ngày cấp</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Xếp loại</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Áp dụng từ ngày</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nhanVien.chungChis && nhanVien.chungChis.filter(cc => cc.loaiChungChi?.trim().toLowerCase() === 'ngoại ngữ').length > 0
                                    ? nhanVien.chungChis
                                        .filter(cc => cc.loaiChungChi?.trim().toLowerCase() === 'ngoại ngữ')
                                        .sort((a, b) => new Date(a.ngayCapChungChi).getTime() - new Date(b.ngayCapChungChi).getTime())
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.tenChungChi}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.donViCap}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.ngayCapChungChi)}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{item.xepLoai}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.apDungTuNgay)}</td>
                                            </tr>
                                        ))
                                    : <tr><td style={{ border: '1px solid black', padding: '2px 4px' }} colSpan={5}>&nbsp;</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Row>
                {/* 26.2) CHỨNG CHỈ TIN HỌC */}
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '2mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        26.2) CHỨNG CHỈ TIN HỌC
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Tên chứng chỉ</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Đơn vị cấp</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Ngày cấp</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Xếp loại</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Áp dụng từ ngày</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nhanVien.chungChis && nhanVien.chungChis.filter(cc => cc.loaiChungChi?.trim().toLowerCase() === 'tin học').length > 0
                                    ? nhanVien.chungChis
                                        .filter(cc => cc.loaiChungChi?.trim().toLowerCase() === 'tin học')
                                        .sort((a, b) => new Date(a.ngayCapChungChi).getTime() - new Date(b.ngayCapChungChi).getTime())
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.tenChungChi}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.donViCap}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.ngayCapChungChi)}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{item.xepLoai}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.apDungTuNgay)}</td>
                                            </tr>
                                        ))
                                    : <tr><td style={{ border: '1px solid black', padding: '2px 4px' }} colSpan={5}>&nbsp;</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Row>
                {/* 26.2) CHỨNG CHỈ KHÁC */}
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '2mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        26.3) CHỨNG CHỈ KHÁC
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Tên chứng chỉ</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Đơn vị cấp</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Ngày cấp</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Xếp loại</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Áp dụng từ ngày</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nhanVien.chungChis && nhanVien.chungChis.filter(cc => (cc.loaiChungChi?.trim()?.toLowerCase() !== 'tin học' && cc.loaiChungChi?.trim()?.toLowerCase() !== 'ngoại ngữ')).length > 0
                                    ? nhanVien.chungChis
                                        .filter(cc => (cc.loaiChungChi.trim()?.toLowerCase() !== 'tin học' && cc.loaiChungChi.trim()?.toLowerCase() !== 'ngoại ngữ'))
                                        .sort((a, b) => new Date(a.ngayCapChungChi).getTime() - new Date(b.ngayCapChungChi).getTime())
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.tenChungChi}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.donViCap}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.ngayCapChungChi)}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{item.xepLoai}</td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.apDungTuNgay)}</td>
                                            </tr>
                                        ))
                                    : <tr><td style={{ border: '1px solid black', padding: '2px 4px' }} colSpan={5}>&nbsp;</td></tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        27) ĐÀO TẠO,  BỒI DƯỠNG VỀ CHUYÊN MÔN NGHIỆP VỤ, LÝ LUẬN CHÍNH TRỊ,  NGOẠI NGỮ, TIN HỌC
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Tên trường
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Chuyên ngành đào tạo, bồi dưỡng
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Từ ngày đến ngày
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Hình thức đào tạo
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Văn bằng, chứng chỉ
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {trinhDoHocVanInfo
                                    .sort((a, b) => new Date(a.ngayBatDau).getTime() - new Date(b.ngayBatDau).getTime())
                                    .map((value, index) => (
                                    <tr key={index} style={{ border: '1px solid black', justifyContent: "center" }}>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                {value.coSoDaoTao}
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                {value.tenChuyenNganhDaoTao}
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                Từ ngày {dateCommon.formatDate(value.ngayBatDau)} đến ngày {dateCommon.formatDate(value.ngayKetThuc)}
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                {value.tenHinhThucDaoTao}
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>

                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                {!trinhDoHocVanInfo || trinhDoHocVanInfo.length === 0 && (
                                    <tr style={{ border: '1px solid black', justifyContent: "center" }}>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Row>
                <Row className="form-group" gutter={2}>
                    <Col span={2} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller', textDecoration: 'underline' }}>
                        Ghi chú:
                    </Col>
                </Row>
                <Row className="form-group" gutter={2}>
                    <Col span={15} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>
                        - Văn bẳng, chứng chỉ: TSKH, TS, chuyên khoa II, Ths, chuyên khoa I, đại học, cao đẳng, trung cấp, sơ cấp, chứng chỉ,...
                    </Col>
                </Row>
                <Row className="form-group" gutter={2}>
                    <Col span={15} className="left-col" style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman', fontStyle: 'italic', fontSize: 'smaller' }}>
                        - Hình thức đào tạo: Chính quy, tại chức, chuyên tu, từ xa, liên thông, bồi dưỡng.
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        28) TÓM TẮT QUÁ TRÌNH CÔNG TÁC
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Từ ngày đến ngày
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black', textAlign: 'left' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Chức danh, chức vụ, đơn vị công tác (đảng, chính quyền, đoàn thể, tổ chức xã hội)
                                            kể cả thời gian được đào tạo, bồi dưỡng về chuyên môn, nghiệp vụ, …
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {nhanVien.quaTrinhCongTacs && nhanVien.quaTrinhCongTacs
                                    .sort((a, b) => new Date(a.ngayBatDau).getTime() - new Date(b.ngayBatDau).getTime())
                                    .map((value, index) => (
                                        <tr key={index} style={{ border: '1px solid black' }}>
                                            <td style={{ border: '1px solid black' }}>
                                                <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                    Từ ngày {dateCommon.formatDate(value.ngayBatDau)} đến ngày {dateCommon.formatDate(value.ngayKetThuc)}
                                                </span>
                                            </td>
                                            <td style={{ border: '1px solid black' }}>
                                                <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                    {value.phongBan && value.phongBan !== "Ban Giám đốc" ? `Làm tại phòng ${value.phongBan}, ` : "Làm "}
                                                    {value.chucVu}
                                                    {value.tenDonVi && value.tenDonVi !== "Ban Giám đốc" ? ` tại ${value.tenDonVi} ` : ""}
                                                </span>
                                            </td>
                                        </tr>
                                    ))}
                                {qTCTInfo
                                    .sort((a, b) => new Date(a.ngayBatDau).getTime() - new Date(b.ngayBatDau).getTime())
                                    .map((value, index) => (
                                        <tr key={index} style={{ border: '1px solid black' }}>
                                            <td style={{ border: '1px solid black' }}>
                                                <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                    Từ ngày {dateCommon.formatDate(value.ngayBatDau)} {value.ngayKetThuc ? ' đến ngày ' + dateCommon.formatDate(value.ngayKetThuc) : ' đến nay'}
                                                </span>
                                            </td>
                                            <td style={{ border: '1px solid black' }}>
                                                <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                                    Làm {value.tenChucVu}
                                                    {value.idDonVi !== 2 && value.tenDonVi ? ` tại ${value.tenDonVi} ` : " tại "}
                                                    Quỹ Đầu tư phát triển thành phố Đà Nẵng
                                                </span>
                                            </td>
                                        </tr>
                                    ))
                                }
                                {(!nhanVien.quaTrinhCongTacs || nhanVien.quaTrinhCongTacs.length === 0) && (!qTCTInfo || qTCTInfo.length === 0) && (
                                    <tr>
                                        <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            </span>
                                        </td>
                                        <td style={{ border: '1px solid black', textAlign: 'left' }}>
                                            <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            </span>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        29) ĐẶC ĐIỂM LỊCH SỬ BẢN THÂN
                    </Col>
                </Row>
                <Row className="form-group" gutter={2}>
                    <Col span={22} style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        - Khai rõ: bị bắt, bị tù (từ ngày tháng năm nào đến ngày tháng năm nào, ở đâu?), đã khai báo cho ai, những
                        vấn đề gì? Bản thân có làm việc trong chế độ cũ
                        (<span style={{ fontStyle: 'italic', fontSize: 'smaller', fontFamily: 'Times New Roman' }}>
                            cơ quan, đơn vị nào, địa điểm, chức danh, chức vụ, thời gian làm việc…
                        </span>):
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                    </Col>
                </Row>
                <Row className="form-group" gutter={2}>
                    <Col span={22} style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        - Tham gia hoặc có quan hệ với các tổ chức chính trị, kinh tế, xã hội nào ở nước ngoài
                        (<span style={{ fontStyle: 'italic', fontSize: 'smaller', fontFamily: 'Times New Roman' }}>
                            (làm gì, tổ chức nào, đặt trụ sở ở đâu ..?)
                        </span>):
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                    </Col>
                </Row>
                <Row className="form-group" gutter={2}>
                    <Col span={22} style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        - Có thân nhân
                        (<span style={{ fontStyle: 'italic', fontSize: 'smaller', fontFamily: 'Times New Roman' }}>
                            (Cha, Mẹ, Vợ, Chồng, con, anh chị em ruột) ở nước ngoài (làm gì, địa chỉ …)
                        </span>)?
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        30) QUAN HỆ GIA ĐÌNH
                    </Col>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        a) Về bản thân: Cha, Mẹ, Vợ (hoặc chồng), các con, anh chị em ruột
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black', textAlign: 'center' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Mối quan hệ
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Họ và tên
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Họ và tên
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Năm sinh
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Quê quán, nghề nghiệp, chức danh, chức vụ, đơn vị công tác, học tập, nơi ở (trong, ngoài nước); thành viên các tổ chức chính trị - xã hội …?)
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ border: '1px solid black' }}>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        b) Về bên vợ (hoặc chồng): Cha, Mẹ, anh chị em ruột
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black', textAlign: 'center' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Mối quan hệ
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Họ và tên
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Họ và tên
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Năm sinh
                                        </span>
                                    </th>
                                    <th style={{ border: '1px solid black' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                            Quê quán, nghề nghiệp, chức danh, chức vụ, đơn vị công tác, học tập, nơi ở (trong, ngoài nước); thành viên các tổ chức chính trị - xã hội …?)
                                        </span>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr style={{ border: '1px solid black' }}>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                    <td style={{ border: '1px solid black', textAlign: 'center' }}>
                                        <span style={{ fontFamily: 'Times New Roman, Times, serif', marginLeft: '10px' }}>
                                        </span>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        31) NGƯỜI PHỤ THUỘC
                    </Col>
                </Row>
                <Row>
                    <div className="card" style={{ width: "100%", display: "flex", justifyContent: "center", fontFamily: 'Times New Roman' }}>
                        <table style={{ fontFamily: 'Times New Roman', border: '1px solid black' }}>
                            <thead>
                                <tr>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Tên người phụ thuộc</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Quan hệ phụ thuộc</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Từ tháng đến tháng</th>
                                    <th style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>Ngày sinh người phụ thuộc</th>
                                </tr>
                            </thead>
                            <tbody>
                                {nhanVien.nguoiPhuThuocs && nhanVien.nguoiPhuThuocs.length > 0
                                    ? nhanVien.nguoiPhuThuocs
                                        .sort((a, b) => a.idQuanHePhuThuoc - b.idQuanHePhuThuoc)
                                        .map((item, index) => (
                                            <tr key={index}>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.hoTenNguoiPhuThuoc}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>{item.tenQuanHe}</td>
                                                <td style={{ border: '1px solid black', padding: '2px 4px' }}>
                                                    {item.thangKetThuc
                                                        ? `Từ tháng ${dateCommon.formatDate(item.thangBatDau, 'MM/yyyy')} đến tháng ${dateCommon.formatDate(item.thangKetThuc, 'MM/yyyy')}`
                                                        : `Từ tháng ${dateCommon.formatDate(item.thangBatDau, 'MM/yyyy')}`
                                                    }
                                                </td>
                                                <td style={{ border: '1px solid black', textAlign: 'center', padding: '2px 4px' }}>{dateCommon.formatDate(item.ngaySinhNguoiPhuThuoc)}</td>
                                            </tr>
                                        ))
                                    : <tr>
                                        <td style={{ border: '1px solid black', padding: '2px 4px' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid black', padding: '2px 4px' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid black', padding: '2px 4px' }}>&nbsp;</td>
                                        <td style={{ border: '1px solid black', padding: '2px 4px' }}>&nbsp;</td>
                                    </tr>
                                }
                            </tbody>
                        </table>
                    </div>
                </Row>
                <Row className="form-group" gutter={8}>
                    <Col span={24} style={{ textAlign: 'center', marginTop: '1mm', fontWeight: 'bold', fontFamily: 'Times New Roman' }}>
                        32) NHẬN XÉT, ĐÁNH GIÁ CỦA ĐƠN VỊ SỬ DỤNG
                    </Col>
                </Row>
                <Row className="form-group" gutter={2}>
                    <Col span={24} style={{ textAlign: 'left', marginTop: '1mm', fontFamily: 'Times New Roman' }}>
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                        ..........................................................................................................................................................................................................................................................................................................................................................................................................
                    </Col>
                </Row>
                <Row gutter={8}  >
                    <Col span={7} className="left-col" style={{ textAlign: 'left', marginLeft: '5mm', fontFamily: 'Times New Roman' }}>
                        <strong style={{ display: "block", textAlign: "left", marginLeft: '15mm', fontWeight: "Black", fontFamily: 'Times New Roman' }}>
                            Người khai
                        </strong>
                        <span style={{ display: "block", textAlign: "left", marginLeft: '3mm', fontFamily: 'Times New Roman' }}>
                            Tôi xin cam đoan những lời
                        </span>
                        <span style={{ display: "block", textAlign: "left", marginLeft: '2.5mm', fontFamily: 'Times New Roman' }}>
                            khai trên đây là đúng sự thật
                        </span>
                        <span style={{ display: "block", textAlign: "left", marginLeft: '10mm', fontFamily: 'Times New Roman', fontStyle: 'italic' }}>
                            (Ký tên, đóng dấu)
                        </span>
                    </Col>
                    <Col span={15} className="right-col" style={{ textAlign: 'right', marginRight: '14mm', fontFamily: 'Times New Roman', fontStyle: 'italic' }}>
                        ..........,ngày......tháng......năm......
                        <br />
                        <strong style={{ display: "block", textAlign: "right", marginRight: '4mm', fontWeight: "Black", fontFamily: 'Times New Roman' }}>
                            Thủ trưởng cơ quan, đơn vị
                        </strong>
                        <span style={{ display: "block", textAlign: "right", marginRight: '14mm', fontFamily: 'Times New Roman', fontStyle: 'italic' }}>
                            (Ký tên, đóng dấu)
                        </span>
                    </Col>
                </Row>

            </PrintPage>
        </div>
    );
};

export default InHoSoNhanVienMoi;
